<template>
  <v-container fluid color="white--text">
    <v-card elevation="5">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="5">
            <v-card flat>
              <v-card-title>Customer To Business (C2B)</v-card-title>
              <v-divider/>
              <v-card-text>
                <h3>Register CallBack URLS for C2B</h3>
                <p>
                  You need to register confirmation which is essential for the C2B transactions. When the payment is successful, a confirmation notification will be sent from Sasa<span class="error--text">Pay</span> to the <code>ConfirmationUrl</code> set.

                </p>
              </v-card-text>
              <v-divider/>
              <v-card-text>
                EndPoints:<br/>
                <div class="secondary" style="color: #e7e3fc">
                  <strong>Sandbox</strong>
                  <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/payments/register-ipn-url/"}}</p>
                  <v-divider/>
                  <strong>Production</strong>
                  <p class="ma-2">{{"https://api.sasapay.app/api/v1/payments/register-ipn-url/"}}</p>
                </div>
              </v-card-text>
              <v-divider/>
              <v-card-text>
                Request Parameters <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> Change <code>MerchantCode</code> to your MerchantCode. <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> Change <code>ConfirmationUrl</code> to your ConfirmationUrl. <br/>

              </v-card-text>
              <v-divider/>
              <v-card-text>
                Expected Results:<br/>

                Sasa<span class="red--text">Pay</span> returns the status code & a detailed message
              </v-card-text>
            </v-card>
          </v-col>
          <v-divider vertical/>
          <v-col cols="12" md="7" class="">
            <h3>Sample Request</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                v-model="code"
                @lang="changeLanguage"
                :wrap_code="false"
                :language_selector="true"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['php','PHP'],['java','Java'],['python', 'Python'],['go','Go'],['csharp','C#'],['javascript', 'Node Js']]"
            ></code-editor>
            <v-divider/>
            <h3>Sample Response</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                v-model="response"
                :wrap_code="false"
                :language_selector="true"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['json','JSON']]"
            ></code-editor>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

import {getC2BCallbackResponse, getRegisterURLC2B} from "../../../../../shared/snippets/c2b/registerCallback";

export default {
  name: "RegisterCallback",
  data: () =>({
    selectedLanguage:"",
    code:"",
    response:"",

  }),
  mounted() {
    this.importSnippets('php')//
    this.importResponse()
  },
  methods:{
    importSnippets(lang){
      this.code=getRegisterURLC2B(lang)
    },
    importResponse(){
      this.response=getC2BCallbackResponse()
    },
    //
    changeLanguage(val) {
      this.importSnippets(val)
    }
  }
}
</script>

<style scoped>

</style>